<template>
  <section v-if="!this.$store.state.page.isMobile" style="min-height: 1300px;">
    <div class="new_page_tabpc" style="padding-left: 13%;">
      <router-link to="/sport/prematch" ><span>벳컨 인플레이</span></router-link>
      <router-link :to="{ name: '오즈매트릭스-인플레이' }" class="cho" ><span>오즈메트릭스 인플레이</span></router-link>
    </div>
    <div class="gameBox" v-if="url">
      <iframe scrolling="no" frameborder="0"
              style="width: 100%; height: 1400px;
          margin:0px 0px 0px 0px; z-index: 1; border: none;"
              allowFullScreen="true"
              :src="url">
      </iframe>
    </div>
  </section>
  <div class="mini-game" v-else style="min-height: 700px;">
    <div class="new_page_tab">
      <router-link to="/sport/prematch"><span>벳컨 인플레이</span></router-link>
      <router-link :to="{ name: '오즈매트릭스-인플레이' }" class="cho"><span>오즈메트릭스 인플레이</span></router-link>
    </div>
    <div>
      <iframe frameborder="0"
              style="width: 100%; min-height: 700px; overflow-y: auto;
              margin:0px 0px 0px 0px; z-index: 1; border: none;"
              allowFullScreen="true"
              webkitallowfullscreen="true"
              :src="url">
      </iframe>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "SportIntegrationInplay",
  components: {
  },
  data: function(){
    return {
      url: null,
      siteName: 'luna',
      pointColor: '#a97bf5',
    }
  },
  mounted() {
    this.initUrl();
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
    }),
  },
  watch: {
    user: function(val){
      if (val) {
        this.initUrl();
      }
    }
  },
  methods: {
    initUrl: function(){
      let token = localStorage.getItem("authToken");
      this.url = null;
      const siteName = this.siteName;
      const pointColor = this.pointColor;
      let baseUrl = 'https://d3hn1xyam8hxou.cloudfront.net/oddsmatrix/inplay/';
      // let baseUrl = 'http://localhost:3000/betconstruct/european/';

      const params = [];
      if (token) {
        params.push(`token=${token}`);
      }
      if (siteName) {
        params.push(`siteName=${siteName}`);
      }
      if (pointColor) {
        params.push(`pointColor=${encodeURIComponent(pointColor)}`);
      }

      if (params.length > 0) {
        this.url = `${baseUrl}?${params.join('&')}`;
      } else {
        this.url = baseUrl;
      }
    }
  }
}
</script>

<style scoped>

</style>
